import { CopyIcon, EditIcon, PlayIcon } from "assets";
import {
  fetchPackageByRefIdInput,
  Packages,
  VideoProps,
} from "../../store/actionType";
import { CustomTooltip, SmallScreenModel } from "components";
import { useEffect, useState } from "react";
import { copyToClipboard } from "utils/helpers/CopyToClipboard";
import { VideoActiveTab } from "props/enum";
import ReadingMaterial from "modules/video/reading_material/ReadingMaterial";
import UpdateVideoVisibility from "../UpdateVideoVisibility";
import EditVideo from "../HandleEditVideo";
import UpdateVideoFeatured from "../UpdateVideoFeatured";
import QuestionAndAnswer from "modules/video/question_and_answer/QuestionAndAnswer";
import HandleUploadVideo from "../HandleUploadVideo";
import HandleUploadThumbnail from "../HandleUploadThumbnail";
import HandleAddPackagesToVideo from "../HandleAddPackagesToVideo";
import { fetchPackageByRefId } from "../../store/action";
import { connect } from "react-redux";
import { Authorities } from "props/authoritries";
import { useUser } from "utils/helpers/UserContext";
import { SuperAdminStatusEnum } from '../../../../../props/enum';
import HandleSetVideoToAnotherGroup from "../HandleSetVideoToAnotherGroup";

interface VideoDetailProps {
  videoDetails: VideoProps;
}
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type StateProps = ReturnType<typeof mapStateToProps>;
type Props = DispatchProps & StateProps & VideoDetailProps;

const VideoDetailDisplay: React.FC<Props> = ({
  videoDetails,
  onFetchPackageByRefId,
  addPackageToVideoState,
}) => {
  const [activeTab, setActiveTab] = useState<VideoActiveTab | null>(null);
  const [posterUrl, setPosterUrl] = useState<string | null>(null);
  const [openUpdateVideo, setOpenUploadVideo] = useState(false);
  const [openUploadthumbnail, setOpenUploadThumbnail] = useState(false);
  const [openPackageModel, setPackageModel] = useState(false);
  const [openSetVideoModel, setSetVideoModel] = useState(false);
  const readAloudVideos =
    videoDetails?.video?.category?.group?.name === "Read Aloud Videos" ||
    videoDetails?.video?.category?.group?.id === "65d514faa5e2fb9f390b04a2";
  const [copied, setCopied] = useState(false);
  const [openEditVideoTitle, setOpenEditVideotitle] = useState(false);
  const handleCopyVdoId = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    const success = await copyToClipboard(videoDetails?.video?.video ?? "");
    if (success) {
      setCopied(true);
      setTimeout(() => {
        setCopied(false);
      }, 1500);
    }
  };
  const handleCopy = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    const success = await copyToClipboard(
      videoDetails?.video?.identifier ?? ""
    );
    if (success) {
      setCopied(true);
      setTimeout(() => {
        setCopied(false);
      }, 1500);
    }
  };
  const videoId = videoDetails?.video?.id?.toString();
  useEffect(() => {
  const controller = new AbortController();

  const fetchVideoMeta = async () => {
    try {
      const videoId = videoDetails?.video?.video?.toString();
      if (!videoId) return;

      setPosterUrl(null);

      const url = `${process.env.REACT_APP_VDO_CIPHER_BASE_URL}${videoId}`;
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Accept: "application/json"
        },
        signal: controller.signal, // 👈 Attach abort signal
      });

      if (response.ok) {
        const data = await response.json();
        const thumbnail = data?.posters[0]?.url;
        setPosterUrl(thumbnail);
      }
    } catch (err:any) {
      if (err.name === "AbortError") {
      } else {
        console.error("Failed to fetch thumbnail", err);
      }
    }
  };

  fetchVideoMeta();

  return () => {
    controller.abort(); // 👈 Cleanup: cancel fetch if component or video changes
  };
}, [videoDetails?.video?.video]);

  useEffect(() => {
  const refId = videoDetails?.video?.id?.toString();
  if (!refId) return;

  const input: fetchPackageByRefIdInput = {
    ref_id: refId,
    content_type: "Video",
  };

  onFetchPackageByRefId(input);
}, [videoDetails?.video?.id, onFetchPackageByRefId]);
  const videoPackages: Packages[] = addPackageToVideoState?.videoPackage;
  const { authUser, action, superAdmin } = useUser();
  const isPermitted =
    authUser &&
    (superAdmin === SuperAdminStatusEnum.SuperAdmin  ||
      action?.includes(Authorities.UPDATE_VIDEO));
  const isCreteRMPermitted =
    authUser &&
    (superAdmin === SuperAdminStatusEnum.SuperAdmin  ||
      action?.includes(Authorities.CREATE_READING_MATERIAL));
  const isQAPermitted =
    authUser &&
    (superAdmin === SuperAdminStatusEnum.SuperAdmin  ||
      action?.includes(Authorities.CREATE_QUESTION_AND_ANSWER));
  return (
    <>
      <section className="Header">
        <div className="w-full flex flex-col md:flex-row bg-white border rounded-md shadow-sm overflow-hidden">
          <div className="w-full md:max-w-[300px] relative group cursor-pointer p-1">
            <div
              onClick={() => setOpenUploadVideo(true)}
              className="w-full h-full flex items-center justify-center border-2 border-dashed hover:border-primary-300  p-1"
            >
              {posterUrl ? (
                <>
                  <img
                    src={posterUrl}
                    alt="Video Poster"
                    className="w-full h-auto object-cover transition duration-200 group-hover:brightness-90"
                  />
                  <div className="absolute inset-0 flex items-center justify-center">
                    <PlayIcon className="size-12 text-white opacity-80 group-hover:opacity-100 transition-opacity" />
                  </div>
                </>
              ) : (
                <div className="w-full h-[150px] flex items-center bg-primary-50 justify-center text-primary-300 hover:text-primary-500">
                  <PlayIcon className="size-12" />
                </div>
              )}
            </div>
            {openUpdateVideo && (
              <SmallScreenModel
                showModal={openUpdateVideo}
                setShowModal={setOpenUploadVideo}
              >
                {isPermitted ? (
                  <HandleUploadVideo
                    posterUrl={posterUrl}
                    closeModal={() => setOpenUploadVideo(false)}
                    videoData={videoDetails}
                  />
                ) : (
                  <div className="text-primary-400 text-center h-[30vh] w-[20vw] flex justify-center items-center">
                    You don't have the permission.
                  </div>
                )}
              </SmallScreenModel>
            )}
          </div>
          <div className="flex flex-col md:flex-row md:justify-between md:items-start gap-4 ">
            <div className="w-full px-6 py-3 flex flex-col">
              <div className="flex items-start justify-between gap-2">
                <div className="flex-1">
                  <div className="flex gap-1 pb-2">
                    <h1 className="text-xl md:text-2xl font-bold text-gray-800 leading-tight">
                      {videoDetails?.video?.title || "Untitled Video"}
                    </h1>
                    <CustomTooltip title="Edit Video Title" placement="right">
                      <button
                        onClick={() => setOpenEditVideotitle(true)}
                        aria-label="Edit Video Title"
                        className="text-primary-400 hover:text-primary-600 transition-colors"
                      >
                        <EditIcon className="size-5" />
                      </button>
                    </CustomTooltip>
                  </div>
                  <p className="text-sm text-gray-500 mt-1">
                    Category:
                    <span className="font-medium text-gray-700">
                      {videoDetails?.video?.category?.name
                        ? videoDetails?.video?.category?.name
                        : "Category not found"}
                    </span>
                  </p>
                  <p className="text-sm text-gray-500 mt-1">
                    Episode:
                    <span className="font-medium text-gray-700">
                      {videoDetails?.video?.episode?.label ? (
                        <>
                          {videoDetails?.video.episode?.label}
                          {videoDetails?.video.episode?.episode_number}
                        </>
                      ) : (
                        "Episode not found"
                      )}
                    </span>
                  </p>
                  <p className="text-sm text-gray-500 mt-1">
                    VdoCipher ID:
                    <span className="font-medium text-gray-700">
                      {videoDetails?.video?.video?.slice(0, 16) + "..." ||
                        "Unavailable"}
                      <CustomTooltip
                        title={copied ? "Id copied!" : "Copy Id"}
                        placement="right"
                      >
                        <button
                          onClick={handleCopyVdoId}
                          className="p-1 hover:text-blue-600"
                        >
                          <CopyIcon className="size-4" />
                        </button>
                      </CustomTooltip>
                    </span>
                  </p>
                  <div className="mt-2 flex items-center gap-2">
                    <button
                      onClick={() => setOpenUploadThumbnail(true)}
                      className="text-white text-[12px] font-medium px-3 py-[6px] bg-primary-500 rounded-md hover:bg-primary-700 hover:shadow-md"
                    >
                      Upload Thumbnail
                    </button>
                    <button
                      onClick={() => setPackageModel(true)}
                      className="text-white text-[12px] font-medium px-3 py-[6px] bg-primary-500 rounded-md hover:bg-primary-700 hover:shadow-md"
                    >
                      Add packages
                    </button>
                    <button
                      onClick={() => setSetVideoModel(true)}
                      className="text-white text-[12px] font-medium px-3 py-[6px] bg-primary-500 rounded-md hover:bg-primary-700 hover:shadow-md"
                    >
                      Set Video to Another Group
                    </button>
                  </div>
                  {openUploadthumbnail && (
                    <SmallScreenModel
                      showModal={openUploadthumbnail}
                      setShowModal={setOpenUploadThumbnail}
                    >
                      {isPermitted ? (
                        <HandleUploadThumbnail
                          closeModal={() => setOpenUploadThumbnail(false)}
                          videoDetails={videoDetails}
                        />
                      ) : (
                        <div className="text-primary-400 text-center h-[30vh] w-[20vw] flex justify-center items-center">
                          You don't have the permission.
                        </div>
                      )}
                    </SmallScreenModel>
                  )}
                </div>
              </div>
            </div>

            <div className="w-full px-6 py-3 flex flex-col">
              <h5 className="text-lg font-semibold text-gray-800 mb-2 w-full whitespace-nowrap">
                Video Packages
              </h5>
              {videoPackages && videoPackages.length > 0 ? (
                <ul className="grid md:grid-cols-3 grid-cols-2 gap-x-6 gap-y-2 text-sm text-gray-700 list-none">
                  {videoPackages.map((item) => (
                    <li
                      key={item.id}
                      className="relative pl-4 before:content-['•'] before:absolute before:left-1 before:text-gray-500 "
                    >
                      {item.package.name}
                    </li>
                  ))}
                </ul>
              ) : (
                <div className="whitespace-nowrap text-primary-200 mt-5 flex flex-col justify-center">
                  <span>No video package to show</span>
                  <span
                    onClick={() => setPackageModel(true)}
                    className="hover:underline hover:text-primary-500 cursor-pointer"
                  >
                    Add video package
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>

        {openEditVideoTitle && (
          <SmallScreenModel
            showModal={openEditVideoTitle}
            setShowModal={setOpenEditVideotitle}
          >
            {isPermitted ? (
              <EditVideo
                closeModal={() => setOpenEditVideotitle(false)}
                videoData={videoDetails.video}
              />
            ) : (
              <div className="text-primary-400 text-center h-[30vh] w-[20vw] flex justify-center items-center">
                You don't have the permission.
              </div>
            )}
          </SmallScreenModel>
        )}
      </section>

      <section className="Body mt-5">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm">
          <div className="space-y-2">
            <p>
              <span className="font-semibold">ID:</span>
              {videoDetails?.video?.id?.toString()
                ? videoDetails?.video?.id?.toString()
                : ""}
            </p>
            <p>
              <span className="font-semibold">Identifier:</span>
              {videoDetails?.video?.identifier}
              <CustomTooltip
                title={copied ? "Id copied!" : "Copy Id"}
                placement="right"
              >
                <button
                  onClick={handleCopy}
                  className="p-1 hover:text-blue-600"
                >
                  <CopyIcon className="size-4" />
                </button>
              </CustomTooltip>
            </p>
            <p>
              <span className="font-semibold">Episode:</span>
              {videoDetails?.video?.episode?.label ? (
                <>
                  {videoDetails?.video.episode?.label}
                  {videoDetails?.video.episode?.episode_number}
                </>
              ) : (
                "Episode not found"
              )}
            </p>
            <p>
              <span className="font-semibold">Category:</span>
              {videoDetails?.video?.category?.name
                ? videoDetails?.video?.category?.name
                : "Category not found"}
            </p>
          </div>
          <div className="space-y-2 truncate ">
            <div>
              <span className="font-semibold">Visibility:</span>
              {videoDetails?.video?.visibility}
              {isPermitted && (
                <UpdateVideoVisibility videoData={videoDetails?.video} />
              )}
            </div>
            <p>
              <span className="font-semibold">Featured:</span>
              {videoDetails?.video?.featured === "true"
                ? "FEATURED"
                : "NOT FEATURED"}
              {isPermitted && (
                <UpdateVideoFeatured videoData={videoDetails?.video} />
              )}
            </p>
            <p>
              <span className="font-semibold">Upload Status:</span>
              {videoDetails?.video?.upload_status
                ? videoDetails?.video?.upload_status
                : "Status not created"}
            </p>
            <p>
              <span className="font-semibold ">OTP:</span>
              {videoDetails?.video?.otp
                ? videoDetails?.video?.otp?.slice(0, 18) + "..."
                : "No OTP"}
            </p>
          </div>
        </div>

        <div className="mt-6">
          <h3 className="text-lg font-semibold mb-2">Playback Info</h3>
          <div className="p-3 bg-gray-100 rounded font-mono text-xs break-words">
            {videoDetails?.video?.playback_info
              ? videoDetails?.video?.playback_info
              : "Could not find the playback ..."}
          </div>
        </div>
      </section>

      {!readAloudVideos && (
        <section className="Questionnaire mt-6">
          <div className="flex gap-4 mb-4">
            <CustomTooltip
              title={`${
                activeTab === VideoActiveTab.Q_AND_A ? "" : "View Q&A"
              }`}
              placement="top"
            >
              <button
                onClick={() => setActiveTab(VideoActiveTab.Q_AND_A)}
                className={`px-4 py-2 rounded-md border ${
                  activeTab === VideoActiveTab.Q_AND_A
                    ? "bg-primary-500 text-white"
                    : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                }`}
              >
                Q & A
              </button>
            </CustomTooltip>
            <CustomTooltip
              title={`${
                activeTab === VideoActiveTab.READING_MATERIAL
                  ? ""
                  : "View Reading Material"
              }`}
              placement="top"
            >
              <button
                onClick={() => setActiveTab(VideoActiveTab.READING_MATERIAL)}
                className={`px-4 py-2 rounded-md border ${
                  activeTab === VideoActiveTab.READING_MATERIAL
                    ? "bg-primary-500 text-white"
                    : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                }`}
              >
                Reading Material
              </button>
            </CustomTooltip>
          </div>
          {activeTab === VideoActiveTab.Q_AND_A && (
            <>
              {isQAPermitted ? (
                <QuestionAndAnswer
                  onClose={() => setActiveTab(null)}
                  videoData={videoDetails?.video}
                />
              ) : (
                <div className="text-primary-400 text-center h-[30vh] w-[20vw] flex justify-center items-center">
                  You don't have the permission.
                </div>
              )}
            </>
          )}
          {activeTab === VideoActiveTab.READING_MATERIAL && (
            <>
              {isCreteRMPermitted ? (
                <ReadingMaterial
                  videoId={videoId}
                  onClose={() => setActiveTab(null)}
                />
              ) : (
                <div className="text-primary-400 text-center h-[30vh] w-[20vw] flex justify-center items-center">
                  You don't have the permission.
                </div>
              )}
            </>
          )}
          {openPackageModel && (
            <SmallScreenModel
              showModal={openPackageModel}
              setShowModal={setPackageModel}
            >
              {isPermitted ? (
                <HandleAddPackagesToVideo
                  videoPackages={videoPackages}
                  videoData={videoDetails?.video}
                  closeModal={() => setPackageModel(!openPackageModel)}
                />
              ) : (
                <div className="text-primary-400 text-center h-[30vh] w-[20vw] flex justify-center items-center">
                  You don't have the permission.
                </div>
              )}
            </SmallScreenModel>
          )}
          {openSetVideoModel && (
            <SmallScreenModel
              showModal={openSetVideoModel}
              setShowModal={setSetVideoModel}
            >
              {isPermitted ? (
                <HandleSetVideoToAnotherGroup
                  videoPackages={videoPackages}
                  videoData={videoDetails?.video}
                  closeModal={() => setPackageModel(!openSetVideoModel)}
                />
              ) : (
                <div className="text-primary-400 text-center h-[30vh] w-[20vw] flex justify-center items-center">
                  You don't have the permission.
                </div>
              )}
            </SmallScreenModel>
          )}
        </section>
      )}
    </>
  );
};

export const mapStateToProps = (state: any) => ({
  addPackageToVideoState: state.videoDetails?.addPackageToVideoState,
});

const mapDispatchToProps = (dispatch: any) => ({
  onFetchPackageByRefId: (input: fetchPackageByRefIdInput) =>
    dispatch(fetchPackageByRefId(input)),
});
export default connect(mapStateToProps, mapDispatchToProps)(VideoDetailDisplay);
